import {Component, Input, Output, EventEmitter, SimpleChanges, ViewChild, OnChanges, OnInit} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MicroSelectComponent} from "../../shared/select/micro-select.component";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'micro-event-classification-select',
  templateUrl: './event-classification-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: EventClassificationSelectComponent
    }
  ]
})
export class EventClassificationSelectComponent implements OnInit, OnChanges, ControlValueAccessor  {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Output()
  idChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  id:any;

  @Input()
  classificationType:string = 'EVENT_CATEGORY';

  @Input()
  parentId:any;

  @Input()
  placeholder:string = 'Select';

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any = '';

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  @Input()
  searchable: boolean = true;

  jump: boolean = false;

  requestedDisabled: boolean = false;
  options:any[];

  onChange = (userId) => {};
  onTouched = () => {};
  touched = false;

  change(e) {
    this.onChange(e);
    this.idChange.emit(e);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  ngOnInit(): void {
    this.requestedDisabled = this.disabled;
    this.reload();
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if ((prop === 'parentId') && this.options) {
        let change = changes[prop];
        if (change.currentValue !== change.previousValue) {
          this.id = undefined;
          this.change(undefined);
        }
        this.reload();
      }
    }
  }

  reload() {
    if (this.requires()) {
      this.options = [];
      return;
    }

    if (this.classificationType !== 'EVENT_CATEGORY' && (!this.parentId || this.parentId === '' || this.parentId === 'undefined')) {
      this.options = [];
      this.disabled = true;
      return;
    }

    this.disabled = this.requestedDisabled;

    this.sel.loading = true;
    let params:HttpParams = new HttpParams();
    params = params.set("classificationType", this.classificationType);

    if (this.parentId && this.parentId !== '' && this.parentId !== 'undefined') {
      params = params.set("parentId", this.parentId);
    }

    return this.http.get(`${this.env.e.url}/task/tickets/eventClassifications`, {params:params})
      .subscribe(data => {
        var dataArray = data as any[];
        let newOptions = [];
        for (var i = 0; i < dataArray.length; i++) {
          newOptions.push({
            id: dataArray[i].id,
            label: dataArray[i].label
          })
        }
        this.options = newOptions;
        this.sel.loading = false;
      });
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(id: string): void {
    this.id = id;
  }


  requires() {
    return null;
  }
}
